import { useRipple } from '../../hook/useRipple';

interface IButton {
  type: 'submit' | 'delete' | 'update';
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * @author taulmax
 * @date 2024.10.09
 * @description 큰 버튼 컴포넌트
 */
const BigButton = ({ type, text, onClick, disabled, style }: IButton) => {
  const { ripples, createRipple } = useRipple();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      createRipple(e);
      onClick(e);
    }
  };

  const getButtonClasses = () => {
    const baseClasses = "relative w-full py-3 px-6 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors overflow-hidden";
    
    switch (type) {
      case 'submit':
        return `${baseClasses} bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 disabled:bg-gray-400`;
      case 'delete':
        return `${baseClasses} bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 disabled:bg-gray-400`;
      case 'update':
        return `${baseClasses} bg-green-600 text-white hover:bg-green-700 focus:ring-green-500 disabled:bg-gray-400`;
      default:
        return `${baseClasses} bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 disabled:bg-gray-400`;
    }
  };

  return (
    <button
      onClick={handleClick}
      className={getButtonClasses()}
      disabled={disabled}
      style={style}
    >
      {text}
      {ripples.map(ripple => (
        <span key={ripple.id} className="ripple" style={ripple.style} />
      ))}
    </button>
  );
};

export default BigButton;
